// extracted by mini-css-extract-plugin
export var box = "_4k-0";
export var check = "_4k-1";
export var checkboxButton = "_4k-6";
export var checkboxGroup = "_4k-5";
export var disabled = "_4k-7";
export var ghost = "_4k-9";
export var input = "_4k-2";
export var label = "_4k-4";
export var normal = "_4k-8";
export var uncheck = "_4k-3";